import {
  Button,
  CircularProgress,
  Container,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { url } from "../../baseUrl";
import { useSelector } from "react-redux";
import axios from "axios";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import {
  brandUrl,
  button,
  cardBackground,
  invoiceCard,
  lightBackground,
  lightText,
  mainBackgound,
  navbar,
  navbarText,
  white,
} from "../../Assets/Theme/ThemeColors";
import CustomizedSnackbars from "../../Components/SnackBar/SnackBar";
import isAlpha from "validator/lib/isAlpha";
import isEmail from "validator/lib/isEmail";
import Navbar from "../../Components/Navbar/Navbar";
import { Badge, Descriptions } from "antd";
import CheckoutForm from "../../Components/StripeCardForm/CheckOutForm";
import "./invoice.css";
import StripeCardForm from "../../Components/StripeCardForm/StripeCardForm";
import logo from "../../Assets/images/logo.webp";
import stripeBadge from "../../Assets/images/stripebadge.png";
import comoo from "../../Assets/images/comoo.png";
import masterCard from "../../Assets/images/masterCard.png";
import norton from "../../Assets/images/norton.png";
import visa from "../../Assets/images/visa.png";
import ssl from "../../Assets/images/ssl.png";
import MailIcon from "@mui/icons-material/Mail";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import ReceiptIcon from "@mui/icons-material/Receipt";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

// Brand Colors
const brandColors = {
  primary: "#1a1e4c",
  accent: "#f7c520",
  white: "#ffffff",
  lightGray: "#f0f2f5",
  darkText: "#1a1e4c",
  lightText: "#94a3b8",
  border: "#e2e8f0",
  gradient: "linear-gradient(135deg, #1a1e4c 0%, #2d3573 100%)"
};

const InvoicePage = () => {
  let { id } = useParams();
  let param = id.split("_");
  const state = useSelector((state) => state.user.data);

  const [data, setData] = useState();
  const [key, setKey] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isPaid, setIsPaid] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [isLoaded, setIsLoaded] = useState(false);

  let invoiceId = param[0];

  var formatter = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP"
  });

  useEffect(() => {
    getSpecificTransaction();
  }, []);

  const getSpecificTransaction = async () => {
    setIsLoading(false);
    await axios
      .post(`${url}/transactions/getSpecificTransaction`, {
        _id: invoiceId,
      })
      .then((response) => {
        setData(response.data.data[0]);
        setKey(response.data.key.publishKey);

        if (response.data.data[0].paymentStatus) {
          setIsPaid(true);
        } else {
          setIsPaid(false);
        }
        setIsLoading(true);
      });
  };

  return (
    <>
      {isLoading ? (
        <>
          {/* Header - White Background with Centered Logo */}
          <Grid
            container
            xs={12}
            sx={{
              height: "80px",
              background: brandColors.white,
              position: "sticky",
              top: 0,
              zIndex: 1000,
              boxShadow: "0 2px 20px rgba(0,0,0,0.08)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <Grid
              item
              xs={12}
              sx={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 2
              }}
            >
              <img src={logo} height="50px" alt="First Class Assignments" />
            
            </Grid>
          </Grid>

          {/* Main Content */}
          <Grid
            container
            style={{
              maxWidth: "100vw",
              minHeight: "calc(100vh - 80px)",
              background: brandColors.lightGray,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "40px 20px"
            }}
          >
            <Grid 
              container 
              spacing={4} 
              maxWidth="lg" 
              justifyContent="center" 
              alignItems="center"  // This centers both columns vertically
            >
              
              {/* Left Column - Beautiful Blue Invoice Card */}
              <Grid item md={6} xs={12} sx={{ display: 'flex' }}>
                <Paper
                  sx={{
                    background: brandColors.gradient,
                    borderRadius: "24px",
                    boxShadow: "0 20px 60px rgba(26, 30, 76, 0.3)",
                    p: 4,
                    width: "100%",
                    position: "relative",
                    overflow: "hidden",
                    alignSelf: 'center'  // Centers within the flex container
                  }}
                >
                  {/* Decorative Elements */}
                  <Box sx={{
                    position: 'absolute',
                    top: -100,
                    right: -100,
                    width: 300,
                    height: 300,
                    borderRadius: '50%',
                    background: 'rgba(247, 197, 32, 0.1)',
                    pointerEvents: 'none'
                  }} />
                  <Box sx={{
                    position: 'absolute',
                    bottom: -150,
                    left: -150,
                    width: 400,
                    height: 400,
                    borderRadius: '50%',
                    background: 'rgba(247, 197, 32, 0.05)',
                    pointerEvents: 'none'
                  }} />

                  {/* Invoice Header */}
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 4, position: 'relative', zIndex: 1 }}>
                    <Box>
                      <Typography variant="h4" sx={{ color: brandColors.white, fontWeight: 700, mb: 1 }}>
                        Invoice
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <ReceiptIcon sx={{ color: brandColors.accent, fontSize: 18 }} />
                        <Typography variant="body2" sx={{ color: brandColors.white, opacity: 0.8 }}>
                          #{data.orderId}
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ 
                      background: data.paymentStatus ? "#10b981" : brandColors.accent,
                      px: 3,
                      py: 1,
                      borderRadius: "30px",
                      boxShadow: data.paymentStatus ? "0 4px 15px rgba(16, 185, 129, 0.3)" : "0 4px 15px rgba(247, 197, 32, 0.3)"
                    }}>
                      <Typography variant="body2" sx={{ 
                        color: data.paymentStatus ? brandColors.white : brandColors.primary, 
                        fontWeight: 700,
                        letterSpacing: "1px",
                        fontSize: "11px"
                      }}>
                        {data.paymentStatus ? "✓ PAID" : "PENDING"}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Customer Info with Icons */}
                  <Box sx={{ mb: 4, position: 'relative', zIndex: 1 }}>
                    <Typography variant="body2" sx={{ color: brandColors.white, opacity: 0.6, mb: 2, letterSpacing: "2px", fontSize: "11px" }}>
                      BILLED TO
                    </Typography>
                    <Typography variant="h5" sx={{ color: brandColors.white, fontWeight: 700, mb: 2 }}>
                      {data.custName}
                    </Typography>
                    
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <EmailIcon sx={{ color: brandColors.accent, fontSize: 18 }} />
                        <Typography variant="body2" sx={{ color: brandColors.white, opacity: 0.9 }}>
                          {data.custEmail}
                        </Typography>
                      </Box>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <PhoneIcon sx={{ color: brandColors.accent, fontSize: 18 }} />
                        <Typography variant="body2" sx={{ color: brandColors.white, opacity: 0.9 }}>
                          {data.custContactNumber}
                        </Typography>
                      </Box>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <CalendarTodayIcon sx={{ color: brandColors.accent, fontSize: 18 }} />
                        <Typography variant="body2" sx={{ color: brandColors.white, opacity: 0.9 }}>
                          {data.dateTime.split(",")[0]}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  {/* Divider */}
                  <Box sx={{ 
                    borderTop: `1px solid rgba(255,255,255,0.1)`,
                    my: 3,
                    position: 'relative',
                    zIndex: 1
                  }} />

                  {/* Invoice Items */}
                  <Box sx={{ position: 'relative', zIndex: 1 }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                      <Typography variant="body2" sx={{ color: brandColors.white, opacity: 0.6, fontWeight: 600, letterSpacing: "1px", fontSize: "11px" }}>
                        DESCRIPTION
                      </Typography>
                      <Typography variant="body2" sx={{ color: brandColors.white, opacity: 0.6, fontWeight: 600, letterSpacing: "1px", fontSize: "11px" }}>
                        AMOUNT
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "space-between", py: 2, borderBottom: `1px solid rgba(255,255,255,0.1)` }}>
                      <Box>
                        <Typography variant="body1" sx={{ color: brandColors.white, fontWeight: 600 }}>
                          {data.discription}
                        </Typography>
                        <Typography variant="body2" sx={{ color: brandColors.white, opacity: 0.7, mt: 0.5, fontSize: "13px" }}>
                          {data.detailDiscription}
                        </Typography>
                      </Box>
                      <Typography variant="body1" sx={{ color: brandColors.white, fontWeight: 600 }}>
                        {formatter.format(data.amount)}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "space-between", py: 2, borderBottom: `1px solid rgba(255,255,255,0.1)` }}>
                      <Typography variant="body2" sx={{ color: brandColors.white, opacity: 0.7 }}>
                        <LocalOfferIcon sx={{ color: brandColors.accent, fontSize: 16, mr: 1, verticalAlign: 'middle' }} />
                        Discount
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#fca5a5" }}>
                        -{formatter.format(data.discount)}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "space-between", py: 2, borderBottom: `1px solid rgba(255,255,255,0.1)` }}>
                      <Typography variant="body2" sx={{ color: brandColors.white, opacity: 0.7 }}>
                        <AccountBalanceWalletIcon sx={{ color: brandColors.accent, fontSize: 16, mr: 1, verticalAlign: 'middle' }} />
                        Taxes & Fees
                      </Typography>
                      <Typography variant="body2" sx={{ color: brandColors.white, opacity: 0.9 }}>
                        {formatter.format(data.additionalCharges)}
                      </Typography>
                    </Box>

                    <Box sx={{ 
                      display: "flex", 
                      justifyContent: "space-between", 
                      pt: 3,
                      mt: 1
                    }}>
                      <Typography variant="h5" sx={{ color: brandColors.white, fontWeight: 700 }}>
                        Total Amount
                      </Typography>
                      <Typography variant="h4" sx={{ color: brandColors.accent, fontWeight: 800 }}>
                        {formatter.format(data.total)}
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </Grid>

              {/* Right Column - Payment Form */}
              <Grid item md={6} xs={12} sx={{ display: 'flex' }}>
                <Paper
                  sx={{
                    background: brandColors.white,
                    borderRadius: "24px",
                    boxShadow: "0 20px 60px rgba(0,0,0,0.08)",
                    p: 4,
                    width: "100%",
                    alignSelf: 'center'  // Centers within the flex container
                  }}
                >
                  <Typography variant="h5" sx={{ color: brandColors.primary, fontWeight: 700, mb: 1 }}>
                    Complete Payment
                  </Typography>
                  <Typography variant="body2" sx={{ color: brandColors.lightText, mb: 4 }}>
                    Secure your order by completing the payment below
                  </Typography>

                  <Box sx={{ 
                    background: `linear-gradient(135deg, ${brandColors.primary} 0%, #2d3573 100%)`,
                    p: 3,
                    borderRadius: "16px",
                    mb: 4,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}>
                    <Box>
                      <Typography variant="body2" sx={{ color: brandColors.white, opacity: 0.8 }}>
                        Amount to Pay
                      </Typography>
                      <Typography variant="h4" sx={{ color: brandColors.white, fontWeight: 700 }}>
                        {formatter.format(data.total)}
                      </Typography>
                    </Box>
                    <Box sx={{ 
                      background: brandColors.accent,
                      px: 3,
                      py: 1.5,
                      borderRadius: "30px",
                      boxShadow: "0 4px 15px rgba(247, 197, 32, 0.3)"
                    }}>
                      <Typography variant="body2" sx={{ color: brandColors.primary, fontWeight: 700, letterSpacing: "1px" }}>
                        GBP
                      </Typography>
                    </Box>
                  </Box>

                  {isPaid ? (
                    <Box sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                      color: brandColors.white,
                      p: 4,
                      borderRadius: "16px",
                      gap: 2
                    }}>
                      <CheckCircleOutlineIcon sx={{ fontSize: 60 }} />
                      <Typography variant="h5" sx={{ fontWeight: 700 }}>
                        Payment Successful!
                      </Typography>
                      <Typography variant="body2" sx={{ opacity: 0.9 }}>
                        Thank you for your payment
                      </Typography>
                    </Box>
                  ) : (
                    <>
                      <StripeCardForm
                        transactionId={invoiceId}
                        amount={Number(data.total)}
                        account={data.account}
                        stripeKey={key}
                      />
                      
                      <Box sx={{ display: "flex", justifyContent: "center", mt: 4, flexWrap: "wrap", gap: 2, alignItems: "center" }}>
                        <img src={stripeBadge} height="35px" alt="Stripe" />
                        <img src={ssl} height="35px" alt="SSL" />
                        <img src={norton} height="35px" alt="Norton" />
                        <img src={visa} height="25px" alt="Visa" />
                        <img src={masterCard} height="22px" alt="Mastercard" />
                      </Box>

                      <Box sx={{ 
                        mt: 4, 
                        pt: 3,
                        borderTop: `2px solid ${brandColors.border}`,
                        display: "flex",
                        justifyContent: "center",
                        gap: 4,
                        flexWrap: "wrap"
                      }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                          <MailIcon sx={{ color: brandColors.accent, fontSize: 20 }} />
                          <Typography variant="body2" sx={{ color: brandColors.lightText, fontSize: "13px" }}>
                            info@firstclassassignments.co.uk
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                          <LocalPhoneIcon sx={{ color: brandColors.accent, fontSize: 20 }} />
                          <Typography variant="body2" sx={{ color: brandColors.lightText, fontSize: "13px" }}>
                            +44 2070 971249
                          </Typography>
                        </Box>
                      </Box>
                    </>
                  )}
                </Paper>
              </Grid>
            </Grid>
          </Grid>

          {/* Footer */}
          <Grid
            container
            xs={12}
            sx={{
              background: brandColors.primary,
              py: 3,
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <Typography variant="body2" sx={{ color: brandColors.white, textAlign: "center", opacity: 0.8 }}>
              © {new Date().getFullYear()} First Class Assignments. All Rights Reserved.
            </Typography>
          </Grid>
        </>
      ) : (
        <Box sx={{ 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center", 
          height: "100vh",
          flexDirection: "column",
          gap: 3,
          background: brandColors.lightGray
        }}>
          <CircularProgress sx={{ color: brandColors.accent }} />
          <Typography variant="h6" sx={{ color: brandColors.primary }}>
            Loading Invoice...
          </Typography>
        </Box>
      )}
      <CustomizedSnackbars
        isOpen={isOpen}
        severity={severity}
        message={message}
      />
    </>
  );
};

export default InvoicePage;